module.exports = __webpack_public_path__ + "ead5a76c62c66566890c72ff7d1b1c2e.png";